import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy, Heart } from "lucide-react";

export default function Leaderboard() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/leaderboard");
        setList(data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div data-testid="leaderboard-page" className="px-6 md:px-12 py-12 max-w-4xl mx-auto">
      <div className="font-mono-acc text-xs text-secondary">// ALL TIME</div>
      <h1 className="font-display text-5xl md:text-6xl mt-3">Top <span className="text-secondary">producers</span>.</h1>

      {loading ? (
        <p className="mt-8 font-mono-acc text-sm text-muted-foreground"><span className="rec-dot mr-2" />Loading...</p>
      ) : (
        <div className="mt-10 border border-border">
          <div className="grid grid-cols-12 font-mono-acc text-[10px] text-muted-foreground border-b border-border p-4">
            <div className="col-span-1">#</div>
            <div className="col-span-7">PRODUCER</div>
            <div className="col-span-2 text-right">WINS</div>
            <div className="col-span-2 text-right">VOTES</div>
          </div>
          {list.map((u, i) => (
            <div
              key={u.id}
              data-testid={`leaderboard-row-${i + 1}`}
              className={`grid grid-cols-12 items-center p-4 border-b border-border last:border-b-0 ${
                i === 0 ? "bg-secondary/5" : ""
              }`}
            >
              <div className="col-span-1 font-display text-2xl">{i + 1}</div>
              <div className="col-span-7 font-display text-xl">
                @{u.username}
                {i === 0 && <Trophy size={14} className="inline ml-2 text-secondary" />}
              </div>
              <div className="col-span-2 text-right font-mono-acc text-sm">{u.wins}</div>
              <div className="col-span-2 text-right font-mono-acc text-sm flex items-center justify-end gap-1">
                <Heart size={12} className="text-primary" /> {u.votes_received}
              </div>
            </div>
          ))}
          {list.length === 0 && (
            <div className="p-8 text-center text-muted-foreground font-mono-acc text-sm">No producers yet.</div>
          )}
        </div>
      )}
    </div>
  );
}
